export default __webpack_public_path__ + "static/media/JungleLife_05.049ff144.png";